import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { RequestEmitirEscolhaPlacaPersonalizada, Types } from './types';

// ACTIONS
import {
	emitirEscolhaPlacaPersonalizadaSuccess,
	emitirEscolhaPlacaPersonalizadaFailure,
} from './actions';

function* emitirEscolhaPlacaPersonalizadaRequest(request: ReducerAction) {
	const { payload }: { payload: RequestEmitirEscolhaPlacaPersonalizada } =
		request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`servicos/${CHANNEL}/emissao/escolha-placa/enviar-placas-personalizadas`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(emitirEscolhaPlacaPersonalizadaSuccess(response.data));
	} else if (response.error) {
		yield put(emitirEscolhaPlacaPersonalizadaFailure());
	}
}

export default all([
	takeLatest(
		Types.EMITIR_ESCOLHA_PLACA_PERSONALIZADA_REQUEST,
		emitirEscolhaPlacaPersonalizadaRequest,
	),
]);
